import React, { useState, useEffect } from 'react'
import { withTranslation, Trans } from 'react-i18next'

import { getCookie, setCookie } from 'utils/cookies'
import { getFullUrlToSsr } from 'utils/router'

const ACCEPT_COOKIES_KEY = 'ACCEPT_COOKIES'

const CookiesBanner = ({ t }) => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        if (getCookie(ACCEPT_COOKIES_KEY)) return
        setIsVisible(true)
    }, [])

    if (!isVisible) return null

    return (
        <div className="cookies-banner">
            <p>
                <Trans
                    i18nKey="We use cookies to optimise your experience of this website. If you continue to use this site, you consent to our use of cookies. For further information, view our <cookieTag>Cookie Policy</cookieTag> and <privacyTag>Privacy Policy</privacyTag>."
                    components={{
                        cookieTag: <a href={getFullUrlToSsr('/cookie-policy')} />,
                        privacyTag: <a href={getFullUrlToSsr('/privacy-policy')}>{t('Privacy Policy')}</a>,
                    }}
                />
            </p>
            <button
                className="button"
                data-variant="primary"
                data-size="md"
                onClick={() => {
                    setCookie(ACCEPT_COOKIES_KEY, true)
                    setIsVisible(false)
                }}
            >
                {t('Accept cookies')}
            </button>
        </div>
    )
}

export default withTranslation('translations')(CookiesBanner)
